const {
    REACT_APP_socketURL: socketsURL,
} = process.env;


export {
    socketsURL,
}